import {PKRequestType} from '../types';

const RequestType: PKRequestType = {
  MANIFEST: 0,
  SEGMENT: 1,
  LICENSE: 2
};

export {RequestType};
